import * as firebase from "firebase/app";
import "firebase/analytics";
import "firebase/auth";
import "firebase/firestore";
import "firebase/functions";

import api from "./api";

const firebaseDevConfig = {
  apiKey: "AIzaSyBtf1DOr4G3qu3b4ARoTcC5cZKsuRbleak",
  authDomain: "autosplit-270a6.firebaseapp.com",
  databaseURL: "https://autosplit-270a6.firebaseio.com",
  projectId: "autosplit-270a6",
  storageBucket: "autosplit-270a6.appspot.com",
  messagingSenderId: "292287860485",
  appId: "1:292287860485:web:b1dd5850db0c680d43716c",
  measurementId: "G-SW7D39R29W",
};

const firebaseProdConfig = {
  apiKey: "AIzaSyC630LwarHRA4fHObAk7TFCQ7_Od8pid2g",
  authDomain: "reconcile-prod.firebaseapp.com",
  databaseURL: "https://reconcile-prod.firebaseio.com",
  projectId: "reconcile-prod",
  storageBucket: "reconcile-prod.appspot.com",
  messagingSenderId: "948780552744",
  appId: "1:948780552744:web:3f210b10511a502dc21b1d",
  measurementId: "G-YTVT9TLN1G",
};

if (api.isProd()) {
  firebase.initializeApp(firebaseProdConfig);
} else {
  firebase.initializeApp(firebaseDevConfig);
  if (api.useLocal)
    firebase.functions().useFunctionsEmulator(api.getFirebaseLocalHost());
}

firebase.firestore();
firebase.analytics();

export default firebase;

export const updateFlags = (uid, flags) => {
  firebase
    .firestore()
    .doc(`users/${uid}`)
    .set(
      {
        flags: {
          ...flags,
        },
      },
      { merge: true }
    );
};
